import type { BackofficeClient } from "@/api/backoffice-v2/backoffice-client";

import { useServices } from "@/services";

export function useBackofficeClient(): BackofficeClient {
  return useServices().backofficeClient;
}
